import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public modal = new BehaviorSubject('');

  constructor() {
  }

  open(idModal: string) {
    console.log(idModal);
    window['$']('#' + idModal).attr('aria-labelledby', idModal);
    window['$']('#' + idModal).modal({backdrop: 'static', show: true});
    this.modal.next(idModal);
  }

  hide(idModal: string) {
    window['$']('#' + idModal).modal('hide');
    window['$']('#' + idModal).removeAttr(idModal);
    this.modal.next(null);
  }
}
